import { IsBoolean, IsEnum, IsOptional } from "class-validator";

export enum InteractivityUnitType {
        PERCENTAGES = 'percentages',
        PIXELS = 'pixels',
}

export enum AnchoringType {
        TOP_LEFT = 'top-left',
        TOP_CENTER = 'top-center',
        TOP_RIGHT = 'top-right',
        MIDDLE_LEFT = 'middle-left',
        CENTER = 'center',
        MIDDLE_RIGHT = 'middle-right',
        BOTTOM_LEFT = 'bottom-left',
        BOTTOM_CENTER = 'bottom-center',
        BOTTOM_RIGHT = 'bottom-right'
}

export class InteractivityDto {
	@IsOptional()
	@IsBoolean()
	enabled?: boolean;

	@IsOptional()
	@IsBoolean()
	dragInteractivity?: boolean;

	@IsOptional()
	@IsBoolean()
	resizeInteractivity?: boolean;

	@IsOptional()
	@IsBoolean()
	styleInteractivity?: boolean;

        @IsOptional()
        @IsEnum(InteractivityUnitType)
        dragUnit?: InteractivityUnitType;

        @IsOptional()
        @IsEnum(AnchoringType)
        anchor?: AnchoringType;

	@IsOptional()
	@IsBoolean()
	highlighted?: boolean;

	@IsOptional()
	@IsBoolean()
	constrainToParent?: boolean;
}

export const defaultEnabledInteractivityConfig = {
	enabled: true,
	dragInteractivity: true,
	resizeInteractivity: true,
	styleInteractivity: true,
	constrainToParent: false
};

export const defaultDisabledInteractivityConfig = {
	enabled: false,
	dragInteractivity: false,
	resizeInteractivity: false,
	styleInteractivity: false,
	constrainToParent: false
};
